import {useEffect, useState} from "react";
import {ThinCloseIcon} from "../../../components/icons/material-icons";
import {HideProgressLoading, ShowProgressLoading} from "../../../components/template/architecture";
import {AuthRedirectAdmins, PostJSON} from "../../../components/api/webservice";
import {Apis} from "../../../components/api/url";
import {ShowSnackbar} from "../../../components/template/snackbar";

export const AdminsPresignupEnableDisableModal = (props: {
    active: boolean,
    closeHandler: any,
    isEnable: boolean,
    tempDisable:boolean,
    onDone: any,
}) => {
    const [enable, setEnable] = useState(false);
    const [temp, setTemp] = useState(false);
    useEffect(() => {
        const isActive = props.active;
        const x = props.isEnable;
        const x1 = props.tempDisable;
        if (isActive) {
            document.body.classList.add("body-no-scroll");
            setEnable(x);
            setTemp(x1);
        } else {
            document.body.classList.remove('body-no-scroll')
        }
    }, [props.active]);
    const saveChanges = () => {
        const e = enable ? '1' : '0';
        const tmp = temp ? '1' : '0';
        ShowProgressLoading();
        PostJSON(
            Apis.server + '/core/admins/presignup/enable',
            {
                active:e,
                temp:tmp,
            },
            true,
            (d: {
                result: string,
                reason: string,
            }) => {
                HideProgressLoading();
                if (d.result !== 'OK') {
                    if (d.reason === 'login')
                        AuthRedirectAdmins();
                    return;
                }
                props.closeHandler();
                props.onDone();
                ShowSnackbar(
                    'وضعیت ثبت‌نام تغییر یافت.',
                    'باشه',
                    5000,
                );
            },
            () => {
            },
            AuthRedirectAdmins,
        ).then(void 0);
    };
    return (
        <>
            <div className={"web-modal-overlay" + (props.active ? ' active' : '')} onClick={props.closeHandler}/>
            <div className={"web-modal" + (props.active ? ' active' : '')} style={{top: 20}}>
                <div className="web-modal-header">
                    <div><b>تغییر وضعیت ثبت‌‌نام</b></div>
                    <button onClick={props.closeHandler}><ThinCloseIcon/></button>
                </div>
                <div className="web-modal-body">
                    <div className="add-student">
                        <label>وضعیت کلی ثبت‌نام چگونه باشد؟</label>
                        <button className={"techaran-radio-box" + (enable ? ' active' : '')}
                                onClick={() => setEnable(true)}>
                            <div><i/></div>
                            <span>فعال</span>
                        </button>
                        <button className={"techaran-radio-box" + (!enable ? ' active' : '')}
                                onClick={() => setEnable(false)}>
                            <div><i/></div>
                            <span>غیرفعال</span>
                        </button>
                        <div style={{height: 20}}/>
                        <label>توقف موقف ثبت نام:</label>
                        <button className={"techaran-switch" + (temp ? '' : ' active')} onClick={()=>setTemp(v=>!v)}>
                            <i><b/></i>
                            <span>{temp ? 'توقف موقت و عدم دریافت ثبت‌نام' : 'فعال و دریافت ثبت‌نام'}</span>
                        </button>
                        <div className="d-flex justify-content-end align-items-center" style={{marginTop: 20, gap: 5}}>
                            <button className="cancel-button" onClick={props.closeHandler}>
                                <b>انصراف</b>
                            </button>
                            <button className="btn-pay" onClick={saveChanges}>
                                <b>ذخیره وضعیت</b>
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};